
// About  - number
  document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".numbers__wrapper--columns");
    if (!wrapper) return;

    const cards = Array.from(wrapper.querySelectorAll(".numbers-card"));
    if (cards.length !== 9) return;
    
    wrapper.classList.add("b7-number");
    wrapper.innerHTML = "";

    // 1~2번째 줄
    const row1 = document.createElement("div");
    row1.className = "b7-numbers__row b7-numbers__row-3"; 

    row1.append(cards[0], cards[1], cards[2], cards[3], cards[4]);

    // 3번째 줄
    const row2 = document.createElement("div");
    row2.className = "b7-numbers__row b7-numbers__row-4";

    row2.append(cards[5],cards[6], cards[7], cards[8]);

    wrapper.append(row1, row2);

    // 첫 번째 카드 세로 2줄 차지
    cards[0].classList.add("b7-numbers__big-card");
  });


// policy - 헤더 배경 색
  document.addEventListener('DOMContentLoaded', () => {
    if (location.pathname === '/policies/privacy-policy') {
      const header = document.querySelector('.header--border');
      if (header) header.style.background = '#151414';
    }
  });


// Scroll Interaction
  document.addEventListener('DOMContentLoaded', () => {
    const AUTO_ACTIVE_SELECTORS = [
      '[id^="Hero-template--"]',
      '[id^="b7-main-blog__template--"]',
    ];

    const OBSERVE_TARGET_IDS = [
      // main c01
      'shopify-section-template--26907687715110__banner_grid_DdaXhT',

      // about c01
      'shopify-section-template--26908964290854__image_with_text_WcVFjD',

      // about c04
      'shopify-section-template--26908964290854__company_info_9RVAK6',

      // whynxone 마지막 배너
      'shopify-section-template--26908982018342__image_banner_nDz3hi',

      // service c03
      'shopify-section-template--26908972187942__multicolumn_UxTnEV',

      // service c04
      'shopify-section-template--26908972187942__collapsible_content_ae79py',

      // global network
      'shopify-section-template--26908972155174__global-network_3RVdK9',

      // blog 상세페이지
      'shopify-section-template--26907687354662__featured_blog',
    ];

    /* Hero / Blog  */
    AUTO_ACTIVE_SELECTORS.forEach(selector => {
      document.querySelectorAll(selector).forEach(section => {
        section.classList.add('b7-scroll__section', 'b7-scroll--active');
      });
    });

    /* Other Section */
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('b7-scroll--active');
          obs.unobserve(entry.target);
        });
      },
      { 
        threshold: 0,
        rootMargin: '0px 0px -30% 0px'
      }
    );

    OBSERVE_TARGET_IDS.forEach(id => {
      const section = document.getElementById(id);
      if (!section) return;

      section.classList.add('b7-scroll__section');
      observer.observe(section);
    });
  });
